<template>
    <b-modal
        :ref="modalRef"
        title-tag="h2"
        :title="'Remove Discount'"
        lazy
        no-close-on-backdrop
        no-close-on-esc
    >
        <div v-if="warningMessagePayment">
            <div class="alert-wrapper">
                <div class="alert alert-warning alert-dismissible" role="alert">
                    {{ warningMessagePayment }}
                </div>
            </div>
        </div>

        <p>
            <span v-if="isInvoice">
                You are about to remove all the discounts applied to this
                invoice, except for discounts associated with wellness plans. Do
                you wish to continue?
            </span>
            <span v-else>
                You are about to remove all the discounts applied to this
                estimate. Do you wish to continue?
            </span>
        </p>

        <template v-slot:modal-footer>
            <modal-footer
                :is-loading="isLoading"
                :is-disabled="isHasUsersChooseInvoice"
                ok-title="Continue"
                @ok-action="save"
                @cancel-action="close"
            />
        </template>
    </b-modal>
</template>
<script type="text/javascript">
import InvoiceService from "@/services/invoice";
import EstimateService from "@/services/estimate";

export default {
    components: {
        modalFooter: () => import("@/components/elements/modal-footer")
    },
    props: {
        modalRef: {
            type: String,
            required: true
        },
        invoiceId: {
            type: String,
            default: null
        },
        estimateId: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            isLoading: false
        };
    },
    computed: {
        isInvoice() {
            // from estimate.vue and invoice.vue will send only invoice-id or estimate-id
            return this.invoiceId != null;
        },
        isHasUsersChooseInvoice() {
            return this.warningMessagePayment !== "";
        },
        warningMessagePayment() {
            return this.invoiceId
                ? this.$store.getters["billing/warningMessagePayment"](
                      this.invoiceId
                  )
                : "";
        }
    },
    methods: {
        open() {
            this.$refs[this.modalRef].show();
        },
        close() {
            this.isLoading = false;
            this.$refs[this.modalRef].hide();
        },
        async save() {
            this.isLoading = true;
            try {
                let response = this.invoiceId
                    ? await InvoiceService.removeDiscount(this.invoiceId)
                    : await EstimateService.removeDiscount(this.estimateId);
                this._message(response.message);
                this.$emit("reload");
                this.close();
            } catch {
                this._message("Error : Unable to remove discount", "danger");
            } finally {
                this.isLoading = false;
            }
        }
    }
};
</script>
